import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
// Import shared components
import { WithAutoLogout } from 'shared-components';
import auth from 'shared-components/src/utils/auth';
// Import Global Components
import PrivateRoute from '../components/PrivateRoute';
// Import Global Layouts
import PrivateLayout from '../layouts/PrivateLayout';
// Import Private Routes
import Home from './Home';
import Profile from './Profile';
import Transfer from './Transfer';
import TaxDocuments from './TaxDocuments';
// Import Page Not Found Components
import NotFound from '../layouts/NotFound';
// Import Utils
import { refresh } from '../utils/auth';

const Private = (props) => {
  const navigate = useNavigate();

  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <PrivateLayout {...props} id="private">
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/transfers/*"
          element={<Transfer />}
        />
        {/* About route removed - now redirects to external knowledge base */}
        <Route
          path="/profile"
          element={<Profile />}
        />
        <Route
          path="/tax-documents"
          element={<TaxDocuments />}
        />
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </PrivateLayout>
  );
};

export default WithAutoLogout(Private, refresh);
